var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationRose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.875 22.1775V24.375C31.875 29.5519 27.6769 33.75 22.5 33.75C17.3231 33.75 13.125 29.5519 13.125 24.375V21.0769",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 33.75V39.375",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 11.25C33.1069 11.25 35.625 13.7681 35.625 16.875C35.625 19.9819 33.1069 22.5 30 22.5H17.9981H17.8125C13.1531 22.5 9.375 18.7219 9.375 14.0625C9.375 9.40313 13.1531 5.625 17.8125 5.625H17.9981H24.375C27.4819 5.625 30 8.14313 30 11.25ZM30 11.25C30 14.3569 27.4819 16.875 24.375 16.875H18.9525H18.8962C17.3437 16.875 16.0838 15.615 16.0838 14.0625C16.0838 12.51 17.3437 11.25 18.8962 11.25H18.9525H22.7025",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationRose);
export default __webpack_public_path__ + "static/media/navigation-rose.c92cd518.svg";
export { ForwardRef as ReactComponent };